import API from './api'
import Request from './http'

export const get = {
  /**
   * 获取文书模板
   * @param params
   * @returns {*|Promise<any>}
   */
  getDocModuleList: function (params) {
    return Request.get(API.API_DOC_MODULE, params)
  },

  /**
   * 获取用户信息
   * @param params
   * @returns {*|Promise<any>}
   */
  getUserInfo: function () {
    return Request.get(API.API_GET_USER_INFO)
  },
  /**
   * 获取产品评论
   * @param params
   * @returns {*|Promise<any>}
   */
  getProductRate: function (id) {
    return Request.get(`${API.API_GET_PRODUCT_RATE}/${id}`)
  },
  /**
   * 获取订单
   */
  getorderType: function () {
    return Request.get(API.API_ORDER_TYPE)
  },

  /**
   * 获取订单动态
   */
  orderDynamic: function () {
    return Request.get(API.API_ORDER_DYNAMIC)
  },

  /**
   * 获取产品详情
   */
  docDetail: function () {
    return Request.get(API.API_DOC_PARAMS)
  },

  /**
   * 获取未接通原因调查问题
   */
  getUnlinkreason: function (params) {
    return Request.get(API.API_UNLINK_REASON, params)
  },
  /**
   * 获取评价标签
   */
  getEvalTag: function (params) {
    return Request.get(API.API_EVAL_TAG, params)
  },
  /**
   * 发律师函详情
   */
  getletterDetail: function (params) {
    return Request.get(API.API_LETTER_ORDERDETAIL, params)
  },

  /**
   * 见面咨询详情
   */
  getFaceDetail: function (params) {
    return Request.get(API.API_FACE_ORDER, params)
  },

  /**
   * 代打官司详情
   */
  getLawsuitDetail: function (params) {
    return Request.get(API.API_LAWSUIT, params)
  },

  /**
   * 律师审核
   */
  getDraftDetail: function (params) {
    return Request.get(API.API_DRAFT_DDETAIL, params)
  },
  /**
   * 取消订单
   */
  cancelOrder: function (params) {
    return Request.get(API.API_CANCEL_ORDER, params)
  },

  /*
   * 获取产品价格
   */
  getPrice: function (params) {
    return Request.get(API.API_PRODUCE_PRICE, params)
  },
  /*
   * 检测三要素
   */
  getThreeElements: function (params) {
    return Request.get(API.API_GET_USER_CHECK_THREE_ELEMENTS, params)
  },
  /**
   *律师起草下单
   */
  getProducts: function (params) {
    return Request.get(API.API_PRODUCTS, params)
  },
  /**
   *商城配置
   */
  getShopList: function (params) {
    return Request.get(API.API_SHOP_LIST, params)
  },
  /**
   * 取消电话咨询订单
   */
  cancelCallOrder: function (params) {
    return Request.get(API.API_Cancel_CallOrder, params)
  },
  /**
   * 获取（待支付订单，待评价订单）状态数量（我的订单红字图标）
   */
  getOrderStatusCount: function (params) {
    return Request.get(API.API_ORDER_STATUS_COUNT, params)
  },
  /**
   * 订单列表
   */
  orderList: function (params) {
    return Request.get(API.API_OEDER_LIST, params)
  },
  /**
   * 未支付的电话咨询订单（未支付不能再次咨询）
   */
  unPayOrder: function (params) {
    return Request.get(API.API_UNPAY_ORDER, params)
  },
  /**
   * 律师列表
   */
  lawyerList: function (params) {
    return Request.get(API.API_LAWYER_LIST, params)
  },

  /**
   * 律师列表&税务师列表（中信私行)
   */
  lawAndPrivateList: function (params) {
    return Request.get(API.API_LAWANDPRi_LIST, params)
  },
  /**
   * 律师列表&税务师列表（YANGJINGJIEDAO)
   */
  lawAndPrivateYjList: function (params) {
    return Request.get(API.API_LAWANDPRYJ_LIST, params)
  },
  /**
   * 税务师列表
   */
  instituteList: function (params) {
    return Request.get(API.API_INSTITUTE_LIST, params)
  },

  /**
   * 律师列表
   */
  homeLawyerList: function (params) {
    return Request.get(API.API_HOME_LAWYER_LIST, params)
  },
  /**
   * 律师详情
   */
  lawyerInfo: function (id) {
    return Request.get(`/uc/lawyerInfo/${ id }`)
  },
  /**
   * 税务师师详情
   */
  instituteInfo: function (id) {
    return Request.get(API.API_INSTITUTE_INFO + '/' + `${ id }`)
  },
  /**
   * 讲师师详情
   */
  lecturerInfo: function (id) {
    return Request.get(API.API_LECTURER_INFO + '/' + `${ id }`)
  },
  /**
   * 私家律师咨询列表
   */
  privateList: function (params) {
    return Request.get(API.API_PRIVATE_LIST, params)
  },
  /**
   * 私家律师详情
   */
  privateInfo: function (id) {
    return Request.get(`/privateCounsel/${ id }`)
  },
  /**
   * 私家律师团列表
   */
  privateInfoList: function (params) {
    return Request.get(API.API_PRIVATE_INFO_LIST, params)
  },
  /**
   * 加入私家律师团
   */
  privateListAdd: function (params) {
    return Request.get(API.API_PRIVATE_ADD, params)
  },
  /**
   * 移除私家律师团
   */
  privateListDelete: function (params) {
    return Request.get(API.API_PRIVATE_DELETE, params)
  },
  /**
   * 资讯列表
   */
  taxExpert: function (params) {
    return Request.get(API.API_TAX_LIST, params)
  },
  contentList: function (params) {
    return Request.post(API.API_CONTENT_LIST, params)
  },
  /**
   * 标签列表
   */
  contentTagList: function (params) {
    return Request.get(API.API_CONTENTTAG_LIST, params)
  },
  /**
     * 标签列表
     */
  popularSearchList: function (params) {
    return Request.get(API.API_POPULARSEARCH_LIST, params)
  },
  /**
   *判断是否完成新手引导
   */
  updateGuide: function (params) {
    return Request.get(API.API_UPDATE_GUIDE, params)
  },

  /**
   *律师履历
   */
  careerReport: function (id) {
    return Request.get(API.API_LAWYER_REPORT+'?id='+id)
  },

  /**
   *案件列
   */
  casesHandled: function (id) {
    return Request.get(API.API_LAWYER_CASE+'?id='+id)
  },

  /**
   *案件详情
   */
  casesDetail: function (id) {
    return Request.get(`${API.API_LAWYER_CASEDETAIL}/${id}`)
  },

  /**
   *查询视频律师会议开始时间
   */
  vcOrderDate: function (params) {
    return Request.get(API.API_VCORDER_DATE, params)
  },

  /**
   *视频律师列表
   */
  vcOrderList: function (params) {
    return Request.get(API.API_VCORDER_LIST, params)
  },

  /**
   *查询视频律师咨询价格
   */
  vcOrderPrice: function (params) {
    return Request.get(API.API_VCORDER_PRICE, params)
  },

  /**
   *视频律师改期
   */
  updateDate: function (params) {
    return Request.get(API.API_UPDATE_DATE, params)
  },
  /**
   *会员权益卡列表
   */
  memberRightList: function (params) {
    return Request.get(API.API_MEMBERRIGHT_LIST, params)
  },
  /**
   *会员权益卡列表
   */
  newMemberRightList: function (params) {
    return Request.get(API.API_NEW_MEMBERRIGHT_LIST, params)
  },
  /**
   *会员权益卡列表
   */
  expiredMemberRightList: function (params) {
    return Request.get(API.API_EXPIRED_MEMBERRIGHT_LIST, params)
  },
  expiredFsMemberRightList: function (params) {
    return Request.get(API.API_FS_MEMBERRIGHT_LIST, params)
  },

  recommendLawyerlist: function (params) {
    return Request.get(API.API_VIDEO_LAWYERLIST, params)
  },
}
export default get



// WEBPACK FOOTER //
// ./src/libs/request/get.js